/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust2_NInputs */

const es_landing_trust2_n = /** @type {(inputs: Landing_Trust2_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100%`)
};

const gl_landing_trust2_n = /** @type {(inputs: Landing_Trust2_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100%`)
};

const en_landing_trust2_n = /** @type {(inputs: Landing_Trust2_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100%`)
};

/**
* | output |
* | --- |
* | "100%" |
*
* @param {Landing_Trust2_NInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_trust2_n = /** @type {((inputs?: Landing_Trust2_NInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust2_NInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_trust2_n(inputs)
	if (locale === "en") return en_landing_trust2_n(inputs)
	return es_landing_trust2_n(inputs)
});